import React from 'react';
import cn from 'classnames';

import { getPlanSubtitle } from './utils';

import styles from './styles.module.scss';

const getTitle = (planVariants, newLinePlanVariants) => {
  if (newLinePlanVariants.length && !planVariants.length) {
    return `Now you need to choose the plan you will use this device.`;
  } else if (newLinePlanVariants.length && planVariants.length) {
    return `You will use this plan or buy a new one that you want to use it with:`;
  } else if (planVariants.length === 1) {
    return `Your plan will be:`;
  } else {
    return `Choose a plan you want to use this device with:`;
  }
};

const ActivationCustomersPlansList = ({
  planVariants,
  newLinePlanVariants,
  selectedVariant,
  handleSelectVariant,
}) => {
  const title = getTitle(planVariants, newLinePlanVariants);

  return (
    <div className={styles.wrapper}>
      <p className={cn('text', styles.title)}>{title}</p>
      {Boolean(planVariants.length) && (
        <ul className={styles.list}>
          {planVariants.map((variant) => {
            const { name, data, type, deviceSn } = variant;
            return (
              <li
                className={cn({
                  [styles.item]: true,
                  [styles.fullWidth]: planVariants.length === 1,
                  [styles.selected]: name === selectedVariant?.name,
                })}
                onClick={() => handleSelectVariant(variant)}
                key={name}
              >
                <div className={cn('text-s', styles.planSubtitle)}>
                  {getPlanSubtitle(data)}
                </div>
                {type === 'per_gb' ? (
                  <div className={styles.amountWrapper}>
                    <span className={cn('h3', styles.amount)}>{data}</span>
                    &nbsp;
                    <span className={cn('text', styles.gb)}>GB</span>
                  </div>
                ) : (
                  <div className={styles.amountWrapper}>
                    <span className={cn('text', styles.amountString)}>
                      {data}
                    </span>
                    &nbsp;
                  </div>
                )}
                {deviceSn && (
                  <>
                    <span className={cn('text-xs', styles.deviceSnTitle)}>
                      Device SN:
                    </span>
                    <span className={cn('text-xs', styles.deviceSn)}>
                      {deviceSn}
                    </span>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default ActivationCustomersPlansList;
